import StatusBadge from "@/components/StatusBadge";

export const columns = () => {
  return [
    // {
    //   accessorKey: "status",
    //   header: "Status",
    //   cell: ({ row }) => <StatusBadge status={row.getValue("status")} />,
    // },
    // {
    //   accessorKey: "order",
    //   header: "Order",
    //   size: 60,
    //   cell: ({ row }) => (
    //     <div className={"flex justify-center"}>{row.getValue("order")}</div>
    //   ),
    // },
    {
      accessorKey: "player_id",
      header: "Player ID",
      cell: ({ row }) => <div>{row.original.player?.code}</div>,
    },
    {
      accessorKey: "player",
      header: "Full Name",
      cell: ({ row }) => <div>{row.original.player?.name}</div>,
    },
    {
      accessorKey: "term",
      header: "Term",
      cell: ({ row }) => <div>{row.original.term?.name}</div>,
    },
    {
      accessorKey: "team",
      header: "Team Name",
      cell: ({ row }) => <div>{row.original.team?.name}</div>,
    },
    {
      accessorKey: "team_id",
      header: "Team ID",
      cell: ({ row }) => <div>{row.original.team?.code}</div>,
    },
  ];
};
